// MARK: NPM Modules
import React, { useState } from "react";
import styled from "styled-components";
// MARK: Redux
import { RootState } from "reduxFunctionality/index";
import { useSelector } from "react-redux";
// MARK: Types
import ReduxStyleguide from "types/redux/styleguide";

// MARK: Styled Components

interface ContainerProps {
  allowsInteraction: boolean;
  dimension: number;
}

const Container = styled.div<ContainerProps>`
  cursor: ${({ allowsInteraction }) => (allowsInteraction ? "pointer" : "")};
  pointer-events: ${({ allowsInteraction }) =>
    allowsInteraction ? "" : "none"};
  width: ${({ dimension }) => dimension}px;
  height: ${({ dimension }) => dimension}px;
  padding: 10px;
`;

const SearchSVG = ({ fillColor, dimension }: SVGProps) => {
  return (
    <svg
      x="0px"
      y="0px"
      width={dimension + "px"}
      height={dimension + "px"}
      viewBox="0 0 544.59 544.59"
      fill={fillColor}
    >
      <path
        d="M534.78,487.31L409.55,362.06c65.4-88.68,57.72-215.94-21.91-295.56C344.73,23.62,287.71,0,227.06,0
	C166.41,0,109.39,23.62,66.51,66.5C23.62,109.4,0,166.41,0,227.05c0,60.65,23.62,117.67,66.51,160.57
	c42.88,42.89,99.9,66.51,160.56,66.51c49.09,0,96.14-15.66,135.04-44.55l125.2,125.18c6.34,6.34,14.77,9.83,23.73,9.83
	c8.99,0,17.43-3.51,23.7-9.8c6.35-6.33,9.85-14.76,9.86-23.73C544.6,502.08,541.11,493.65,534.78,487.31L534.78,487.31z
	 M227.06,67.11c42.72,0,82.88,16.64,113.1,46.85c30.16,30.15,46.77,70.31,46.77,113.09s-16.61,82.94-46.77,113.1
	c-30.21,30.21-70.37,46.85-113.09,46.85s-82.88-16.64-113.1-46.85c-30.21-30.2-46.85-70.36-46.85-113.1
	c0-42.72,16.64-82.88,46.85-113.09C144.19,83.76,184.35,67.11,227.06,67.11L227.06,67.11z"
      />
    </svg>
  );
};

// MARK: React Component
// Props
interface Props {
  allowsInteraction: boolean;
}
// Styleguide & Datapoints
const getDataPoints = (styleguide: ReduxStyleguide) => {
  const { colors } = styleguide;
  const { primary, secondary } = colors;
  return {
    primary: primary,
    secondary: secondary,
  };
};
// Component
const SearchIcon = ({ allowsInteraction }: Props) => {
  // Mark: React Redux Variables
  const styleguide: ReduxStyleguide = useSelector(
    (state: RootState) => state.styleguide
  );
  // Mark: State Variables
  const [hover, setHover] = useState(false);
  // Mark: Component Specific Variables
  const { primary, secondary } = getDataPoints(styleguide);
  const dimension = 20;
  // MARK: Render
  return (
    <Container
      dimension={40}
      allowsInteraction={allowsInteraction}
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
      onTouchStart={() => {
        setHover(true);
      }}
      onTouchEnd={() => {
        setHover(false);
      }}
      onTouchCancel={() => {
        setHover(false);
      }}
    >
      <SearchSVG
        fillColor={hover && allowsInteraction ? secondary : primary}
        dimension={dimension}
      />
    </Container>
  );
};

interface SVGProps {
  fillColor: string;
  dimension: number;
}

export default SearchIcon;
